import React from "react";
import {isWeapp, noop} from "@firefly/fly-defter";
import {useMemoizedFn} from "@firefly/fly-hook";
import { WechatSDK } from "./lib/sdk";
import useReady from "./hook/useReady";

export interface ShareProps {
  title?: string;
  description?: string;
  coverUrl?: string;
  link?: string;
  enabled?: boolean;
  onSuccess?: () => void;
  children: React.ReactElement;
}


function Share(props: ShareProps): React.ReactElement {
  const {
    title,
    //避免空白效果更好
    description,
    coverUrl,
    link,
    enabled = true,
    onSuccess = noop,
    children,
  } = props;

  const onSuccessFn = useMemoizedFn(onSuccess);
  useReady(() => {
    if (!isWeapp() && enabled && link) {
      const options = {
        title: title,
        desc: description ? description : title,
        imgUrl: coverUrl,
        link: link,
        success: onSuccessFn,
      };
      WechatSDK.updateAppMessageShareData(options);
      WechatSDK.updateTimelineShareData(options);
    }
  }, [enabled, title, description, coverUrl, link]);
  return children;
}

export default Share;
